import "../App.css";
import WebLayout from "../layout/WebLayout";
import Banner from "../components/banners/Banner";
import CategoryProducts from "../components/products/category/products";
import { useCategoryProductsFetch } from "../hooks/useCategoryProductsFetch";
import { useSelector } from "react-redux";
import DiscountedProduct from "../components/products/discounted/DiscountedProduct";
import PremiumBrands from "../components/brands/PremiumBrands";
import { useHomeBrandFetch } from "../hooks/useHomeBrandFetch";

function Home() {
  const { randomCategoryProducts } = useSelector((state) => state.product);
  const { storeCity } = useSelector((state) => state.auth);
  const [categoryLoader] = useCategoryProductsFetch("random", storeCity);
  const { brand } = useSelector((state) => state.brand);
  useHomeBrandFetch();

  return (
    <WebLayout pagname="Home">
      <div className="row">
        <div className="col-md-12">
          <Banner />
        </div>
      </div>

      <div>
        {randomCategoryProducts.length > 0 &&
          randomCategoryProducts.map((data, index) => {
            if (data.products.length === 0) return null;

            return (
              <div key={index}>
                <CategoryProducts
                  categoryName={data.name}
                  categotyUrl={data.slug_url}
                  categoryProducts={data.products}
                />
                {index + 1 === 1 && <DiscountedProduct />}
                {index + 1 === 3 && <PremiumBrands brandList={brand} />}
              </div>
            );
          })}
      </div>
    </WebLayout>
  );
}

export default Home;
